// extracted by mini-css-extract-plugin
export default {"icon":"ClearInputIcon__icon--3LJ"};